module.exports = __webpack_public_path__ + "h5/img/child-nav4.d7c7fce0.png";